import React from 'react';
import classnames from 'classnames';
import posed from 'react-pose';

const PoseAccordionContents = posed.div({
    open: { height: 'auto' },
    closed: { height: 0 }
});

export const AccordionContents = ({ isOpen, ...props }) => {
    return <PoseAccordionContents pose={isOpen ? 'open' : 'closed'} style={{ overflowY: 'hidden' }} {...props} />;
};

const Accordion = ({
    className,
    children,
    defaultOpen
}) => {

    const [open, setOpen] = React.useState(defaultOpen || false);

    const handleItemClick = () => {
        setOpen(!open);
    };

    return (
        <div
            className={classnames('accordion', className, {
                is_open: open
            })}
        >
            {children({
                open: open,
                handleItemClick: handleItemClick
            })}
        </div>
    );
}

export default Accordion;
